module.exports = __webpack_public_path__ + "assets/img/u_info-circle.cbd4c36d.svg";